module.exports = __webpack_public_path__ + "static/media/comment.0e1199f0.svg";